<section class="single-work-section">
    <div class="transition-2">
        <div class="single-page-wrapper overflow-hidden page-padding" [ngStyle]="videoPlaying && {'height':screenHeight + 'px'}">
            <div id="single-grid" class="page-container transition-grid position-relative"
            #gridcontainer
            [ngClass]="{'overflow-hidden': videoPlaying}"
            [ngStyle]="{'transform': 'translateY(' + counter + 'px)', '-webkit-transform': 'translateY(' + counter + 'px)', '-moz-transform': 'translateY(' + counter + 'px)', '-o-transform': 'translateY(' + counter + 'px)'}" 
            mouseWheel
            (mouseWheelDown)="mouseWheelDownFunc($event)"
            (mouseWheelUp)="mouseWheelUpFunc($event)">
                    
                <div *ngIf="screenWidth > 1024" id="scroll-grid" class="grid" >
                    <div class="grid-item" *ngFor="let module of modules; let i = index" 
                        [ngClass]="{'grid-item-8-module remove-space position-relative overflow-hidden': module.element_size == 8 && module.module_type == 'banner' && i == 0,
                        'grid-item-8': module.element_size == 8,
                        'grid-item-6': module.element_size == 6,
                        'grid-item-4': module.element_size == 4,
                        'grid-item-2': module.element_size == 2,
                        'grid-item-1': module.element_size == 1}">
                            <app-banner-module
                            [ngClass]="{'slide-module': i == 0}"
                            #bannermodule
                            class="item-container w-100 h-100"
                            *ngIf="module.module_type == 'banner'"
                            [module]="module"
                            [slug]="slug"
                            [title]="title"
                            [subtitle]="subtitle"
                            [counter]="counter"
                            [i]='i'
                            (returnIndexItem)=returnIndexItem($event)
                            >
                            </app-banner-module>
                            <app-content-module 
                            class="item-container w-100 h-100 position-relative d-block overflow-hidden"  
                            *ngIf="module.module_type == 'content'"
                            [module]='module'>
                        
                            </app-content-module>
                            <app-slider-module 
                            class="item-container w-100 h-100 position-relative" 
                            *ngIf="module.module_type == 'slider'" 
                            [postColor]="postColor"
                            [logo]="logo"
                            [i]='i'
                            [module]='module'>
                            </app-slider-module>
                            <app-gallery-module 
                            class="item-container w-100 h-100 " 
                            *ngIf="module.module_type == 'gallery'" 
                            [module]='module'
                            [postColor]="postColor"
                            [logo]="logo"
                            [i]='i'>
                        </app-gallery-module>
                    </div>
                    <div *ngIf="modules && tags" class="position-relative" [ngClass]="{'grid-item-8': screenWidth > 1024, 'grid-item grid-item-full w-100': screenWidth <= 1024}">
                        <app-related-posts
                            #related
                            (relatedActive)="handleRelatedPosts($event)"
                            (emitPauseScroll)="handleScrollPause($event)"
                            [title]='tagstitle'
                            [tags]='tags'
                            [counter]="counter"
                            class="item-container w-100 h-100">
                        </app-related-posts>
                    </div>
                    <div *ngIf="modules && screenWidth <= 1024" class="grid-item grid-item-full w-100 overflow-hidden remove-grid-borders footer-top-border">
                        <app-footer></app-footer>
                    </div>
                </div>


                <div *ngIf="screenWidth <= 1024" id="scroll-grid" class="grid grid-m animate-single" 
                    [ngClass]="{'animate-fade': animatePage, 'animate-fade-related': animateFromRelated}"
                >
                    <div class="grid-item grid-item-m-auto" *ngFor="let module of modules | sortBy; let i = index" 
                        [ngClass]="{'overflow-hidden remove-grid-borders': module.element_size == 8 && module.module_type == 'banner'  && i == 0,
                        'grid-item-8-t': module.element_size == 8,
                        'grid-item-6-t': module.element_size == 6,
                        'grid-item-4-t': module.element_size == 4,
                        'grid-item-2-t': module.element_size == 2,
                        'grid-item-1-t': module.element_size == 1}">
                            <app-banner-module
                            [ngClass]="{'slide-module': i == 0, 
                                        'transition':transitionAnimation,
                                        'transform-next-slide':transformNextPage,
                                        'transform-prev-slide':transformPrevPage,
                                        'transform-next-slide-active': nextPostActive}"
                            #bannermodule
                            class="item-container w-100 h-100"
                            *ngIf="module.module_type == 'banner'"
                            [module]="module"
                            [slug]="slug"
                            [title]="title"
                            [subtitle]="subtitle"
                            [counter]="counter"
                            [i]='i'
                            (returnIndexItem)=returnIndexItem($event)
                            >
                            </app-banner-module>
    
                            <app-content-module 
                            class="item-container w-100 h-100 position-relative d-block overflow-hidden grid-item-space"  
                            *ngIf="module.module_type == 'content'"
                            [module]='module'>
                        
                            </app-content-module>
                            
                            <app-slider-module 
                            class="item-container w-100 h-100 position-relative" 
                            *ngIf="module.module_type == 'slider'" 
                            [postColor]="postColor"
                            [logo]="logo"
                            [i]='i'
                            [module]='module'>
                            </app-slider-module>
    
                            <app-gallery-module 
                            class="item-container w-100 h-100 " 
                            *ngIf="module.module_type == 'gallery'" 
                            [module]='module'
                            [postColor]="postColor"
                            [logo]="logo"
                            [i]='i'>
                        </app-gallery-module>
                    </div>
                    <div *ngIf="modules && tags" class="position-relative" [ngClass]="{'grid-item-8': screenWidth > 1024, 'grid-item grid-item-full w-100': screenWidth <= 1024}">
                        <app-related-posts
                            #related
                            (relatedActive)="handleRelatedPosts($event)"
                            (emitPauseScroll)="handleScrollPause($event)"
                            [title]='tagstitle'
                            [tags]='tags'
                            [counter]="counter"
                            class="item-container w-100 h-100">
                        </app-related-posts>
                    </div>
                    <div *ngIf="modules && screenWidth <= 1024" class="grid-item grid-item-full w-100 overflow-hidden remove-grid-borders-footer">
                        <app-footer></app-footer>
                    </div>
                </div>

                <div  id="footer" *ngIf="modules && screenWidth > 1024" class="w-100 H-100-full overflow-hidden remove-grid-borders">
                    <app-footer></app-footer>
                </div>
                <div *ngIf="screenWidth > 767" class="d-none d-lg-block fade-overlay-menu fade-overlay-single" [ngClass]="{'active': activateMenuOverlay}"></div>
            </div>
        </div>  
    </div>

    <div class="w-100 overflow-hidden">
        <app-related-overlay #relatedOverlay class="item-container w-100 h-100 overflow-hidden"></app-related-overlay>
    </div>
    
  
</section>

